<template>
  <base-modal :modal-id="modalId" :modalSize="'lg'">
    <template v-slot:header>
      <h4 class="modal-title mb-0">+ {{ _T('Add Customer Address') }}</h4>
    </template>

    <template v-slot:modal-body>
      <create-address-form
        ref="customerAddressForm"
        :address="address"
        :coordinates="coordinates"
        :showfotterButtons="true"
        @close-modal="closeModal()"
      ></create-address-form>
      <div class="btns">
        <button
          type="button"
          class="btn btn-outline"
          @click.prevent="closeModal"
        >
          {{ _T('Cancel') }}
        </button>
        <progress-bar v-if="processInProgress(process)">
          {{ _T('Saving') }}
        </progress-bar>
        <button
          v-else
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click.prevent="validateData()"
        >
          {{ _T('Save') }}
        </button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CustomerAddress',
  props: ['address', 'coordinates'],
  data: () => ({
    modalId: 'add-address',
    process: 'customer-address',
  }),
  computed: {
    ...mapGetters(['_T', 'processInProgress']),
  },
  methods: {
    validateData() {
      this.$refs.customerAddressForm.validateForm()
    },
    closeModal() {
      this.$refs.customerAddressForm.resetForm()
      this.$bvModal.hide(this.modalId)
    },
  },
  components: {
    BaseModal: () => import('@/components/Modals/BaseModal.vue'),
    CreateAddressForm: () => import('./CustomerAddress/CreateAddressForm.vue'),
    ProgressBar: () => import('@/components/Elements/ProgressBar.vue'),
  },
}
</script>

<style lang="scss">
#add-address___BV_modal_outer_ {
  #add-address {
    padding-left: 0 !important;
  }
}
</style>
